import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { GiftItemRow } from '@models/gift';
import { Link } from '@router/Link';
import { useTranslation } from 'react-i18next';

interface Props {
    giftItem: GiftItemRow;
}

function PrepaidCardItem({ giftItem }:Props) {
    const {
        name, salePrice, imageUrl, status, id,
    } = giftItem;
    const { t } = useTranslation('gift');
    return (
        <Link activityParams={{ type: 'GIFT', giftItemId: id }}
            activityName='PrepaidCardImagesActivity'
            style={{ width: '100%' }}>
            <Column align='center' fullWidth>
                <ImageContainer>
                    <PrepaidCardImage src={imageUrl}
                        alt={name}
                        width={148}
                        height={88} />
                    {status === 'SOLD_OUT' && (
                        <Dim>
                            <SoldOut>
                                <Text color={colors.white}
                                    fontWeight='bold' >
                                    {t('item.soldOut')}
                                </Text>
                            </SoldOut>
                        </Dim>
                    )}
                </ImageContainer>
                <Text>{name}</Text>
                <Text size='lg' fontWeight='bold'>
                    {salePrice.toLocaleString()}{t('item.priceUnit')}
                </Text>
            </Column>
        </Link>
    );
}

const PrepaidCardImage = styled(Image)`
    height: auto;
    width: 100%;
    aspect-ratio: 1.68;
    border-radius: 4px;
    object-fit: cover;
`;

const ImageContainer = styled.div`
    position: relative;
    margin-bottom: 10px;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
`;

const Dim = styled.div`
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const SoldOut = styled.div`
    position: absolute;
    width: 88px;
    height: 24px;
    display:flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.3);
    transform: rotate(-18deg);
`;

export default PrepaidCardItem;
